import { render, staticRenderFns } from "./TableBuscadorEmpleados.vue?vue&type=template&id=0edf12dc"
import script from "./TableBuscadorEmpleados.vue?vue&type=script&lang=js"
export * from "./TableBuscadorEmpleados.vue?vue&type=script&lang=js"
import style0 from "./TableBuscadorEmpleados.vue?vue&type=style&index=0&id=0edf12dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports